import { render, staticRenderFns } from "./InputSpecificComments.vue?vue&type=template&id=26930f75&scoped=true"
import script from "./InputSpecificComments.vue?vue&type=script&lang=js"
export * from "./InputSpecificComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26930f75",
  null
  
)

export default component.exports